import { ApiService } from './../core/api-service/api.service';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CaseManagementService {
  baseUrlForAxlePoint = environment.baseUrlForAxlePoint;
  baseUrl = environment.baseUrl;
  baseUrlForFleetAssist = environment.baseUrlForFleetAssist;
  getWOStatusForNewDashBoardCustomerViewUrl = this.baseUrlForAxlePoint + 'api/alxepoint/workorder/customer/wo';
  getWorkOrderCountByStatusPrecedenceUrl = this.baseUrlForAxlePoint + 'api/alxepoint/workorder/count';
  addUserURL = this.baseUrl + 'api/customers/user/driver';
  getUserDetailsUrl = this.baseUrl + 'api/customers/user/getDrivers';
  getWorkOrderByWorkOrderIdUrl = this.baseUrl + 'api/workOrder/';
  private getLastHourMetricsIp: string = this.baseUrlForAxlePoint + 'api/alxepoint/workorder/customer/lastHourMetric';
  getCustomerParentInformationIdUrl = this.baseUrl + 'api/questionare/customerParentInformationId/';
  getMmsCasesUrl = this.baseUrl + "api/dashboard/mmsCases";
  getActiveCasesUrl = this.baseUrl + "api/dashboard/activeCases";
  getCompanyUrl = this.baseUrlForFleetAssist + 'api/fleetAssist/GetCustomerParentCustomerId_V1';
  getDropdownUrl = this.baseUrlForFleetAssist + 'api/fleetAssist/Get_DropDownForCustomerDashBoard';
  getTableDataUrl = this.baseUrlForAxlePoint + 'api/alxepoint/workorder/invoiceHistoryAndCost';
  getTableDataByDateUrl = this.baseUrlForAxlePoint + 'api/alxepoint/workorder/invoiceHistoryAndCost';
  getActiveAssetsCountForDashboardURL = this.baseUrlForFleetAssist + 'api/fleetAssist/getActiveAssetsCountForDashboard'
  getOverandPMDueRegulatoryCountURL = this.baseUrlForFleetAssist + 'api/fleetAssist/getOverandPMDueRegulatoryCount'
  getAssetMasterErrorsURL = this.baseUrlForFleetAssist + 'api/fleetAssist/GetAssetMasterErrors'
  getMeterErrorDueURL = this.baseUrlForFleetAssist + 'api/fleetAssist/GetAssetMeterErrorTwo'
  getAddRowUrl = this.baseUrlForFleetAssist + 'api/fleetAssist/getWORODetails/';

  woKey: number;
  isFrom: string;
  selectedFilterColumns: any = [];

  constructor(private http: HttpClient, private apiService: ApiService) { }

  // FOR ADDING ROWS IN DATA_TABLE
  getAddRow(value) {
    return this.apiService.get(this.getAddRowUrl + value);
  }

  //FOR DROPDOWN IN EVENT_FILE
  getDropdown(dropdata): Observable<any> {
    return this.http.post(this.getDropdownUrl, dropdata);
  }

  getMeterErrorDue(data): Observable<any> {
    return this.http.post(this.getMeterErrorDueURL, data);
  }

  getAssetMasterErrors(data): Observable<any> {
    return this.http.post(this.getAssetMasterErrorsURL, data);
  }

  getOverandPMDueRegulatoryCount(data): Observable<any> {
    return this.http.post(this.getOverandPMDueRegulatoryCountURL, data);
  }

  getActiveAssetsCountForDashboard(data): Observable<any> {
    return this.apiService.post(this.getActiveAssetsCountForDashboardURL, data);
  }

  lastHourMetrics(data) {
    var headerData = {
      "token": "TTNFleet2018"
    };
    var reqHeader = new HttpHeaders(headerData);
    return this.http.post(this.getLastHourMetricsIp, data, { headers: reqHeader });
  }


  getWOStatusForNewDashBoardCustomerView(data): Observable<any> {
    var headerData = {
      "token": 'TTNFleet2018',
    };

    var reqHeader = new HttpHeaders(headerData);
    return this.http.post(this.getWOStatusForNewDashBoardCustomerViewUrl, data, { headers: reqHeader });
  }

  getWorkOrderCountByStatusPrecedence(data): Observable<any> {
    var headerData = {
      "token": 'TTNFleet2018',
    };
    var reqHeader = new HttpHeaders(headerData);
    return this.http.post(this.getWorkOrderCountByStatusPrecedenceUrl, data, { headers: reqHeader });
  }

  getWorkOrderByWorkOrderId(workOrderId): Observable<any> {
    return this.http.get(this.getWorkOrderByWorkOrderIdUrl + workOrderId);
  }

  //For admin panel //////////////
  addUser(addUserDetails) {
    return this.http.post(this.addUserURL, addUserDetails);
  }

  getUserDetails(userDetails) {
    return this.http.post(this.getUserDetailsUrl, userDetails);
  }

  getCustomerParentInformationId(email) {
    return this.http.get(this.getCustomerParentInformationIdUrl + email);
  }

  getCompany() {
    return this.http.get(this.getCompanyUrl);
  }

  getTableData(): Observable<any> {
    var tabledata =
    {
      "customerId": sessionStorage.getItem('legacyCustomerKeyId'),
      "divisionId": 0,
      "endDate": "2019-01-21T13:33:50.195Z",
      "locationId": 0,
      "regionId": 0,
      "startDate": "2017-08-14T13:33:50.195Z"
    };
    var headerData = {
      "token": 'TTNFleet2018',
    };
    var reqHeader = new HttpHeaders(headerData);
    return this.http.post(this.getTableDataUrl, tabledata, { headers: reqHeader });
  }

  getTableDataByDate(data): Observable<any> {
    var headerData = {
      "token": 'TTNFleet2018',
    };
    var reqHeader = new HttpHeaders(headerData);
    return this.http.post(this.getTableDataByDateUrl, data, { headers: reqHeader });
  }

  setWorkOrderKey(woKey) {
    this.woKey = woKey;
  }
  getWorkOrderKey() {
    return this.woKey;
  }

  getCalculateWODowntime(woServiceKey: number): Observable<any> {
    const body = {
      woServiceKey: woServiceKey,
    }
    return this.http.post<any>(`${environment.baseUrl}calculateWODowntime`, body);
  }

  getWoRoViewDetails(woServiceKey: number): Observable<any> {
    const body = {
      woServiceKey: woServiceKey,
    }
    return this.http.post<any>(`${environment.baseUrl}getWoRoViewDetails`, body);
  }

  getCODOptions(groupKey: number): Observable<any> {
    const body = {
      groupKey: groupKey,
    }
    return this.http.post<any>(`${environment.baseUrl}getCODOptions`, body);
  }

  getMaxETCDetails(woServiceKey: number): Observable<any> {
    const body = {
      woServiceKey: woServiceKey,
    }
    return this.http.post<any>(`${environment.baseUrl}getMaxETCDetails`, body);
  }

  getWORODetails(woServiceKey: number): Observable<any> {
    const body = {
      woServiceKey: woServiceKey,
    }
    return this.http.post<any>(`${environment.baseUrl}getWORODetails`, body);
  }

  getROSubService(serviceTypeId: number) {
    return this.http.get<any>(`${environment.baseUrl}api/vendorSearch/GetVendorSubServiceSearch/${serviceTypeId}`);
  }

  getWoViewNotesDetails(woServiceKey: number): Observable<any> {
    const body = {
      woServiceKey: woServiceKey,
    }
    return this.http.post<any>(`${environment.baseUrl}getWoViewNotesDetails`, body);
  }

  removeWoNoteDetails(woServiceKey: number): Observable<any> {
    const body = {
      woServiceKey: woServiceKey,
    }
    return this.http.post<any>(`${environment.baseUrl}removeWoNoteDetails`, body);
  }

  updateWoRoViewDetails(woRoViewDetails): Observable<any> {
    return this.http.post(`${environment.baseUrl}updateWoRoViewDetails`, woRoViewDetails);
  }

  getAllROStatus(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getAllROStatus`);
  }

  addEANoteDetails(arrUpdateNote): Observable<any> {
    return this.http.post(`${environment.baseUrl}insertEANoteDetails`, arrUpdateNote);
  }

  getWOCountByStatusPrescendenceByTeamOrCustomer(statusPrecedence, type): Observable<any> {
    const body = {
      customerKey: sessionStorage.getItem('legacyCustomerKeyId'),
      subCustomerKey: sessionStorage.getItem('ersSubcustomerId'),
      divisionid: sessionStorage.getItem('fleetDivisionId'),
      locationId: sessionStorage.getItem('fleetLocationId'),
      vendorId: 0,
      clientTeam: 0,
      statusPrecedence: statusPrecedence,
      groupBy: type
    };
    return this.http.post(`${environment.baseUrlForAxlePoint}getWOCountByStatusPrescendenceByTeamOrCustomer`, body);
  }

  getPendingDispatchRODetails(data): Observable<any> {
    return this.http.post(`${environment.baseUrlForAxlePoint}getERSGraphRODetails`, data);
  }

  getRODetailsByStatus(data): Observable<any> {
    return this.http.post(`${environment.baseUrlForAxlePoint}getERSGraphRoDetailByStatus`, data);
  }

  getMetricsDataForCustomer(body): Observable<any> {
    return this.http.post(`${environment.baseUrl}getMetricsDataByCustomerKey`, body);
  }

  requestLocation(driverName, driverNumber): Observable<any> {
    const body = {
      "driverName": driverName,
      "driverNumber": driverNumber
    };
    return this.http.post(`${environment.baseUrl}api/customers/requestLocation`, body);
  }

  getDropAndPicksWoCount(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}api/customers/getDropAndPicksWoCount`, data);
  }

  getCustomerInspectonDueCount(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}api/customers/getCustomerInspectonDueCount`, data);
  }

  getOperationalAssetCount(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}api/customers/getOperationalAssetCount`, data);
  }

  getNonOperationalAssetCount(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}api/customers/getNonOperationalAssetCount`, data);
  }

  getInspectionOverDuePrimaryCount(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}api/customers/getInspectionOverDuePrimaryCount`, data);
  }

  getPendingDispatchWOCount(data): Observable<any> {
    return this.http.post(`${environment.baseUrlForAxlePoint}getPendingDispatchWOCount`, data);
  }

  getCaseManagementActiveData(data): Observable<any> {
    return this.http.post(`${environment.baseUrlForAxlePoint}getCaseManagementActiveData`, data);
  }

  getCompanyRegion(data): Observable<any> {
    return this.http.get(`${environment.baseUrl}getCompanyRegion/${data}`);
  }

  getCompanyDivision(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}getCompanyDivision`, data);
  }

  getCompanyLocation(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}getCompanyLocation`, data);
  }

  getWorkOrderAttachment(woKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getWorkOrderAttachment/${woKey}`);
  }

  getEmailAndFaxHistory(woKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getEmailAndFaxHistory/${woKey}`);
  }

  getWorkOrderHierarchyDetails(woKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getWorkOrderHierarchyDetails/${woKey}`);
  }

  saveWoNote(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}addWoNote`, data);
  }

  getCustomerServiceRequestQuestions(data): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}api/workOrder/getCustomerServiceRequestQuestions`, data);
  }

  setIsFromVerificationLink(isFrom: string) {
    this.isFrom = isFrom;
  }

  getIsFromVerificationLink() {
    return this.isFrom;
  }

  getVendorInvoices(woKey): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}getVendorInvoice/${woKey}`);
  }

  getROStatusCounts(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}getRODetailsDashboardCounts`, data);
  }

  getAuthorShopKey(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}getAuthorShopKey`, data);
  }

  getCustomerDispatchDetails(data): Observable<any> {
    return this.http.post(`${environment.baseUrl}getCustomerDispatchDetail`, data);
  }

  uploadAttachment(uploadData): Observable<any> {
    return this.http.post(`${environment.baseUrl}api/customers/uploadAttachments`, uploadData);
  }

  setSelectedFilterColumns(columns) {
    this.selectedFilterColumns = columns;
  }

  getSelectedFilterColumns() { 
    return this.selectedFilterColumns;
  }
  getWinterStromProcess(data: any): Observable<any> {
    return this.http.post(`${environment.baseUrl}api/workOrder/getWinterStromProcessDetails`, data);
  }

}

export interface CustomResponse {
  status: "",
  message: "",
  error: "",
  body: any;
}
